import React from "react";
import parcel_point_icon from "./../assets/images/parcel_point_icon.png";
import locker_icon from "./../assets/images/locker_icon.png";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const SelectedServices = (props) => {
    const { selected_pickup, selected_dropoff, selected_service } = props;

    const selected_dropoff_box = <div className={`mt-3 ${(selected_dropoff === 'pp') ? 'bg-[#1D2953]' : 'bg-[#E5854A]'} text-white py-5 px-10 rounded-lg flex flex-col items-center justify-center text-center`}>
        <img src={(selected_dropoff === 'pp') ? parcel_point_icon : locker_icon} alt={(selected_dropoff === 'pp') ? "Point Drop-off" : "Kiosk Drop-off"} className="mb-2 w-16 h-16" />
        <p className="text-sm font-bold">{(selected_dropoff === 'pp') ? 'Point' : 'Kiosk'}</p>
    </div>;

    const selected_pickup_box = (selected_service.length > 0) ? <div className={`mt-3 ${selected_service[0].color} text-white py-5 px-10 rounded-lg flex flex-col items-center justify-center text-center`}>
        <img src={selected_service[0].icon} alt="Point Drop-off" className="mb-2 w-16 h-16" />
        <p className="text-sm font-bold">{selected_service[0].text}</p>
    </div> : null;

    return (
        <React.Fragment>
            <div className="flex flex-col md:flex-row items-center justify-evenly md:justify-between gap-4 mt-4">
                <div className="flex-1 flex justify-center">
                    {selected_dropoff_box} 
                </div>
                
                {(selected_pickup && selected_dropoff) && (
                    <div className="flex flex-1 justify-center">
                        <ArrowForwardIcon fontSize="large" />
                    </div>
                )}

                <div className="flex-1 flex justify-center">
                    {selected_pickup_box}
                </div>
            </div>
        </React.Fragment>
    );
}

export default SelectedServices;